<template>
  <div v-if="loaded" v-show="active" class="cp-tabs_pane">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CPTabPane',
  props: {
    name: String,
    label: String
  },
  data() {
    return {
      index: null,
      loaded: false
    }
  },
  computed: {
    paneName() {
      return this.name || this.index
    },
    active() {
      const flag = this.$parent.currentName === this.paneName
      return flag
    }
  },
  watch: {
    active(val) {
      if (val) {
        this.loaded = true
      }
    }
  },
  updated() {
    this.$parent.$emit('tab-nav-update')
  }
}
</script>
